<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
    <line class="cls-5" x1="72.39" y1="16.21" x2="14.81" y2="73.79"/>
    <g>
      <g>
        <circle class="cls-1" cx="65.04" cy="56.45" r="16.21"/>
        <path class="cls-2" d="m65.04,73.79c-9.56,0-17.34-7.78-17.34-17.34s7.78-17.34,17.34-17.34,17.34,7.78,17.34,17.34-7.78,17.34-17.34,17.34Zm0-32.42c-8.32,0-15.08,6.76-15.08,15.08s6.77,15.08,15.08,15.08,15.08-6.77,15.08-15.08-6.76-15.08-15.08-15.08Z"/>
      </g>
      <path class="cls-2" d="m65.04,45.63c-.16,0-.28-.13-.28-.28v-2.47c0-.16.13-.28.28-.28s.28.13.28.28v2.47c0,.16-.13.28-.28.28Z"/>
      <g>
        <line class="cls-1" x1="55.45" y1="46.85" x2="56.39" y2="47.79"/>
        <path class="cls-2" d="m56.39,48.07c-.07,0-.14-.03-.2-.08l-.93-.94c-.11-.11-.11-.29,0-.4s.29-.11.4,0l.93.94c.11.11.11.29,0,.4-.06.06-.13.08-.2.08Z"/>
      </g>
      <g>
        <line class="cls-1" x1="51.48" y1="56.45" x2="53.95" y2="56.45"/>
        <path class="cls-2" d="m53.95,56.73h-2.47c-.16,0-.28-.13-.28-.28s.13-.28.28-.28h2.47c.16,0,.28.13.28.28s-.13.28-.28.28Z"/>
      </g>
      <g>
        <line class="cls-1" x1="55.86" y1="65.63" x2="56.79" y2="64.7"/>
        <path class="cls-2" d="m55.86,65.92c-.07,0-.14-.03-.2-.08-.11-.11-.11-.29,0-.4l.94-.94c.11-.11.29-.11.4,0s.11.29,0,.4l-.94.94c-.06.06-.13.08-.2.08Z"/>
      </g>
      <g>
        <line class="cls-1" x1="65.04" y1="70.01" x2="65.04" y2="67.54"/>
        <path class="cls-2" d="m65.04,70.29c-.16,0-.28-.13-.28-.28v-2.47c0-.16.13-.28.28-.28s.28.13.28.28v2.47c0,.16-.13.28-.28.28Z"/>
      </g>
      <g>
        <line class="cls-1" x1="74.23" y1="65.63" x2="73.3" y2="64.7"/>
        <path class="cls-2" d="m74.23,65.92c-.07,0-.14-.03-.2-.08l-.94-.94c-.11-.11-.11-.29,0-.4s.29-.11.4,0l.94.94c.11.11.11.29,0,.4-.06.06-.13.08-.2.08Z"/>
      </g>
      <g>
        <line class="cls-1" x1="78.61" y1="56.45" x2="76.14" y2="56.45"/>
        <path class="cls-2" d="m78.61,56.73h-2.47c-.16,0-.28-.13-.28-.28s.13-.28.28-.28h2.47c.16,0,.28.13.28.28s-.13.28-.28.28Z"/>
      </g>
      <g>
        <line class="cls-1" x1="74.23" y1="46.85" x2="73.3" y2="47.79"/>
        <path class="cls-2" d="m73.3,48.07c-.07,0-.14-.03-.2-.08-.11-.11-.11-.29,0-.4l.94-.94c.11-.11.29-.11.4,0s.11.29,0,.4l-.94.94c-.06.06-.13.08-.2.08Z"/>
      </g>
      <g>
        <line class="cls-1" x1="51.48" y1="56.45" x2="53.95" y2="56.45"/>
        <path class="cls-2" d="m53.95,56.73h-2.47c-.16,0-.28-.13-.28-.28s.13-.28.28-.28h2.47c.16,0,.28.13.28.28s-.13.28-.28.28Z"/>
      </g>
      <g>
        <line class="cls-1" x1="65.04" y1="70.01" x2="65.04" y2="67.54"/>
        <path class="cls-2" d="m65.04,70.29c-.16,0-.28-.13-.28-.28v-2.47c0-.16.13-.28.28-.28s.28.13.28.28v2.47c0,.16-.13.28-.28.28Z"/>
      </g>
      <g>
        <line class="cls-1" x1="78.61" y1="56.45" x2="76.14" y2="56.45"/>
        <path class="cls-2" d="m78.61,56.73h-2.47c-.16,0-.28-.13-.28-.28s.13-.28.28-.28h2.47c.16,0,.28.13.28.28s-.13.28-.28.28Z"/>
      </g>
      <g>
        <polyline class="cls-1" points="61.66 47.87 65.04 56.45 73.76 60.48"/>
        <path class="cls-6" d="m73.76,61.33c-.12,0-.24-.02-.36-.08l-9.03-4.17-3.51-8.89c-.17-.44.04-.93.48-1.1.43-.17.93.04,1.1.48l3.26,8.26,8.41,3.89c.43.2.61.7.41,1.13-.14.31-.45.49-.77.49Z"/>
      </g>
    </g>
    <g>
      <rect class="cls-4" x="23.33" y="19.84" width=".54" height="25.59"/>
      <path class="cls-4" d="m33.37,45.97H13.82c-1.96,0-3.56-1.6-3.56-3.56v-19.55c0-1.96,1.6-3.56,3.56-3.56h19.55c1.96,0,3.56,1.6,3.56,3.56v19.55c0,1.96-1.6,3.56-3.56,3.56ZM13.82,20.38c-1.37,0-2.48,1.11-2.48,2.48v19.55c0,1.37,1.11,2.48,2.48,2.48h19.55c1.37,0,2.48-1.11,2.48-2.48v-19.55c0-1.37-1.11-2.48-2.48-2.48H13.82Z"/>
      <g>
        <g>
          <path class="cls-3" d="m30.95,28.24c-.11,0-.22.02-.3.09-.87.65-2.07,1.05-3.39,1.05s-2.54-.41-3.41-1.07c-.07-.05-.17-.08-.26-.08v-11.66h6.66l.7,11.67Z"/>
          <path class="cls-7" d="m27.27,29.55c-1.33,0-2.58-.39-3.52-1.1-.04-.03-.09-.04-.15-.04h-.18v-12.02h7l.72,12.03h-.2c-.07-.01-.14.01-.18.04-.94.7-2.18,1.09-3.5,1.09Zm-3.49-1.48c.07.02.13.05.19.09.88.67,2.05,1.03,3.3,1.03s2.4-.36,3.28-1.02c.06-.05.13-.08.22-.1l-.68-11.33h-6.31v11.33Z"/>
        </g>
        <g>
          <path class="cls-3" d="m16.93,16.57l-.7,11.67c-.09,0-.18.03-.25.09-.87.65-2.07,1.05-3.39,1.05-.11,0-.22,0-.33,0-2.97-.15-4.93-2.41-4.1-4.56l.36-.95,2.57-6.71c.13-.35.55-.59,1.04-.59h4.8Z"/>
          <path class="cls-7" d="m12.59,29.55c-.11,0-.23,0-.34,0-1.69-.09-3.16-.84-3.93-2.03-.56-.86-.68-1.85-.32-2.77l2.93-7.65c.16-.42.64-.7,1.2-.7h4.99l-.72,12.02h-.16c-.06,0-.11.03-.15.06-.93.7-2.17,1.09-3.49,1.09Zm-.46-12.81c-.41,0-.76.19-.87.47l-2.93,7.65c-.31.81-.21,1.68.29,2.45.71,1.09,2.08,1.79,3.65,1.87.11,0,.22,0,.32,0,1.24,0,2.41-.36,3.28-1.01.06-.04.12-.07.19-.09l.68-11.34h-4.61Z"/>
        </g>
        <path class="cls-6" d="m23.6,16.57v11.66c-.1,0-.19.02-.26.08-.87.66-2.07,1.07-3.41,1.07s-2.52-.4-3.38-1.05c-.09-.06-.2-.09-.31-.09l.7-11.67h6.67Z"/>
        <path class="cls-6" d="m34.94,29.37c-.11,0-.22,0-.33,0-1.32,0-2.52-.4-3.39-1.05-.07-.05-.17-.08-.27-.09l-.7-11.67h4.84c.46,0,.87.23,1,.56l2.58,6.73.36.95c.82,2.15-1.14,4.41-4.1,4.56Z"/>
      </g>
      <path class="cls-4" d="m26.07,36.39c-.25,0-.45-.2-.45-.45v-2.05c0-.25.2-.45.45-.45s.45.2.45.45v2.05c0,.25-.2.45-.45.45Z"/>
      <path class="cls-4" d="m21.35,36.39c-.25,0-.45-.2-.45-.45v-2.05c0-.25.2-.45.45-.45s.45.2.45.45v2.05c0,.25-.2.45-.45.45Z"/>
      <path class="cls-4" d="m34.61,29.73c-1.35,0-2.63-.4-3.6-1.12-.03-.02-.11-.02-.14,0-.97.73-2.25,1.12-3.6,1.12s-2.65-.41-3.62-1.14c-.02-.01-.08-.01-.1,0-.97.74-2.26,1.14-3.62,1.14s-2.63-.4-3.6-1.12c-.03-.02-.11-.02-.13,0-.97.72-2.25,1.12-3.6,1.12-.12,0-.23,0-.35,0-1.75-.09-3.27-.88-4.08-2.12-.59-.91-.71-1.95-.34-2.93l2.93-7.66c.19-.49.74-.81,1.37-.81h22.97c.61,0,1.15.32,1.33.79l2.94,7.68c.37.98.25,2.02-.34,2.93-.8,1.23-2.33,2.03-4.08,2.11-.12,0-.23,0-.35,0Zm-3.67-1.86c.18,0,.36.05.5.16.84.63,1.97.98,3.17.98.1,0,.21,0,.31,0,1.52-.08,2.83-.75,3.51-1.79.47-.72.56-1.53.27-2.28l-2.94-7.68c-.06-.17-.31-.34-.67-.34H12.13c-.33,0-.62.15-.7.36l-2.93,7.65c-.29.76-.19,1.57.27,2.28.68,1.04,1.99,1.71,3.52,1.79.1,0,.21,0,.31,0,1.2,0,2.33-.35,3.17-.98.28-.21.71-.21.99,0,.84.63,1.97.98,3.17.98s2.34-.35,3.19-1c.27-.21.68-.21.96,0,.85.64,1.98,1,3.19,1s2.33-.35,3.17-.98c.14-.11.32-.16.5-.16Z"/>
    </g>
</svg>
</template>

<script>
export default {
    name: "RetailerVsROMTimelineIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #fff;
  }
  .cls-2 {
    fill: #0f5b71;
  }
  .cls-3 {
    fill: #b3decd;
  }
  .cls-4 {
    fill: #115c72;
  }
  .cls-5 {
    fill: none;
    stroke: #cfeae0;
    stroke-linecap: round;
    stroke-miterlimit: 10;
    stroke-width: 4px;
  }
  .cls-6 {
    fill: #59c5c7;
  }
  .cls-7 {
    fill: #135d73;
  }
</style>
